import {
  IBoxesInitialValues,
  IBoxUpdate,
  ILogoUpd,
} from '@store/modules/boxes/types';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { catchAxiosError } from '@utils/utils';

import BoxesService from '@services/boxes';

const initialState: IBoxesInitialValues = {
  webHook: {
    isWebhookEnabled: false,
    webhookUrl: null,
    webhookAuthType: null,
    webhookAuthToken: null,
    webhookEvents: null,
    lastCallInfo: {
      timestamp: '',
      statusCode: '',
      statusMessage: null,
    },
  },
  boxes: [],
};

export const getWebHook = createAsyncThunk(
  'boxes/webHook',
  async (boxOguid: string, { rejectWithValue }) => {
    try {
      const response = await BoxesService.getWebHook(boxOguid);

      return response.data;
    } catch (err) {
      return catchAxiosError(err, rejectWithValue);
    }
  }
);

export const getBoxes = createAsyncThunk(
  'boxes/getBoxes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await BoxesService.getBoxes();

      return response.data;
    } catch (err) {
      return catchAxiosError(err, rejectWithValue);
    }
  }
);

export const updateBox = createAsyncThunk(
  'boxes/updateBox',
  async (data: IBoxUpdate, { rejectWithValue }) => {
    try {
      const response = await BoxesService.updateBox(data);

      return response.data;
    } catch (err) {
      return catchAxiosError(err, rejectWithValue);
    }
  }
);

export const boxesSlice = createSlice({
  initialState,
  name: 'boxes',
  reducers: {
    deleteBox: (state, action: PayloadAction<string>) => {
      state.boxes = state.boxes.filter((val) => val.oguid !== action.payload);
    },
    updateBoxLogo: (state, action: PayloadAction<ILogoUpd>) => {
      state.boxes = state.boxes.map((val) =>
        val.oguid === action.payload.boxOguid
          ? {
              ...val,
              logo: action.payload.logo,
            }
          : val
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWebHook.fulfilled, (state, action) => {
        if (!action.payload) return;

        state.webHook = action.payload;
      })
      .addCase(getBoxes.fulfilled, (state, action) => {
        if (!action.payload) return;

        state.boxes = action.payload;
      })
      .addCase(updateBox.fulfilled, (state, action) => {
        const { boxOguid, data } = action.meta.arg;

        state.boxes = state.boxes.map((val) =>
          val.oguid === boxOguid
            ? {
                ...val,
                ...data,
              }
            : val
        );
      });
  },
});

const { reducer, actions } = boxesSlice;

export const { deleteBox, updateBoxLogo } = actions;

export default reducer;
